import React, { useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Grid,
  Box,
  Drawer,
  Hidden,
  List,
  IconButton,
  makeStyles,
  Collapse,
} from "@material-ui/core";

import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  Briefcase as Clientes,
  Activity as Lecturas,
  Plus,
} from "react-feather";
import NavItem from "./NavItem";
import navigationConfig from "./navigationConfig";
import { ModalFormularioV2Tablero, Page } from "components";
import LogoTiBlanco from 'assets/logo ti blanco.svg';
import FormTablero from "views/Tablero/Components//FormulariosTablero/FormTablero";
import serviciosTablero from "utils/serviciosTablero";
import clsx from 'clsx';

const user = {
  avatar: "/static/images/avatars/avatar_6.png",
  jobTitle: "Senior Developer",
  name: "Katarina Smith",
};
const iconos = {
  dash: BarChartIcon,
  ctlPrv: AlertCircleIcon,
};
const useStyles = makeStyles((theme) => ({
  root: {
      background: '#2d3239',
      color: '#ffffff'
  },
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
  },
  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
  name: {
    textAlign: "center",
  },
  navigation: {
    marginTop: theme.spacing(2),
  },
}));

const NavBar = ({ onMobileClose, openMobile, openDesktop, info }) => {
  const classes = useStyles();
  const location = useLocation();
  const [categoriaAbierta, setCategoriaAbierta] = useState(null);
  const [modalCrearTablero, setModalCrearTablero] = useState({ open: false });
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ open: false });
  const cambiarCategoriaAbierto = (id) => (event) => {
    if (id === categoriaAbierta) setCategoriaAbierta(null);
    else setCategoriaAbierta(id);
  };
  const abrirFormTablero = () =>
    serviciosTablero.getCtlsTablero(
      (data) => {
        setModalCrearTablero({
          open: true,
          titulo: "Crear tablero",
          props: {
            setCargando: setCargando,
            idtablero: null,
            action: "insert",
            ctls: {
              nombres: data?.participantes || [],
              solicitudes: data?.solicitudes || [],
            },
            defaultValue: null,
          },
          aceptar: guardarTablero,
        });
      },
      setCargando,
      { action: "insert", idtablero: null }
    );
  const cerrarFormTablero = () => setModalCrearTablero({ open: false });
  const cerrarMensaje = () => setMensaje({ open: false });
  const guardarTablero = (data) => {
    cerrarFormTablero();
    serviciosTablero.crearTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0) window.location.reload();
      },
      setCargando,
      data
    );
  };
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column" className={clsx(classes.root)}>
      <Page
        title=""
        className={{}}
        mensaje={{ ...mensaje, cerrar: cerrarMensaje }}
        cargando={cargando}
      ></Page>
      <Box p={2} className={clsx(classes.root)}>
        <List className={clsx(classes.root)}>
          {navigationConfig(info.rutas).map((list) => (
            <React.Fragment key={list.title} className={clsx(classes.root)}>
              <Grid container spacing={1} className={clsx(classes.root)}>
                <Grid xs={list.id_pagina == "tableroList" ? 10 : 12} className={clsx(classes.root)}>
                  <NavItem
                    href={list.href}
                    title={list.title}
                    tipo={list.children ? 1 : 2}
                    id={list.id_pagina}
                    icon={list.icon}
                    cambioMenuActivo={cambiarCategoriaAbierto}
                    open={list.id_pagina === categoriaAbierta}
                    className={clsx(classes.root)}
                  />
                </Grid>
                {list.id_pagina == "tableroList" && (
                  <Grid xs={2}>
                    <IconButton
                      title="Crear nuevo tablero"
                      onClick={abrirFormTablero}
                      style={{color: "white"}}
                    >
                      <Plus />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
              {list.children && (
                <Collapse
                  in={list.id_pagina === categoriaAbierta}
                  timeout="auto"
                  unmountOnExit
                  className={clsx(classes.root)}
                >
                  <List component="div" disablePadding>
                    {list.children.map((sub) => (
                      <NavItem
                        href={sub.href}
                        // href={'/dashboard/'+sub.href}
                        key={sub.id_pagina}
                        icon={sub.icon}
                        title={sub.title}
                        tipo={3}
                        setModalCrearTablero={setModalCrearTablero}
                        modalCrearTablero={modalCrearTablero}
                        abrirFormTablero={abrirFormTablero}
                      />
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
        <ModalFormularioV2Tablero
          open={modalCrearTablero?.open || false}
          titulo="Crear tablero"
          aceptar={guardarTablero}
          onCerrar={cerrarFormTablero}
        >
          <FormTablero {...modalCrearTablero.props} />
        </ModalFormularioV2Tablero>
      </Box>
      <Box sx={{ flexGrow: 1 }}></Box>
      <Box
        xs={2}
        style={{ display:"flex", flexDirection:"column", padding: '40px 20px' }}
        className={clsx(classes.root)}
      >
        <img alt="Logo" src={LogoTiBlanco} height="120px" style={{ margin: 'auto' }} />
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open={openDesktop}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

NavBar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false,
};

export default NavBar;
